import { FormGroup } from '@angular/forms';

export function litterQualityValidator(
  litterQualityLoosePercentage: string,
  litterQualityCakedPercentage: string,
  litterQualityWetPercentage: string,
) {
  return (group: FormGroup): { [key: string]: boolean } => {
    const loose = group.controls[litterQualityLoosePercentage].value;
    const caked = group.controls[litterQualityCakedPercentage].value;
    const wet = group.controls[litterQualityWetPercentage].value;

    if (loose === null && caked === null && wet === null) {
      return null;
    }

    if (loose + caked + wet !== 100) {
      return { litterQualityInvalid: true };
    }
    return { litterQualityInvalid: false };
  };
}
